<template>
  <el-card :shadow="'never'" class="photo">
    <div slot="header" class="clearfix">
      <!-- <span class="text">{{photo.key.split('/')[1]}}</span> -->

      <em
        style=" float:left; font-size:16px; margin-right:10px; line-height:20px; color:#121212"
      >{{date}}</em>
      <el-dropdown hide-on-click trigger="click" @command="handleCommand" class="pointNumber">
        <span class="el-dropdown-link">
          <em class="el-icon-arrow-down el-icon--right"></em>
        </span>
        <el-dropdown-menu v-if="checkPermission('deleteMeasurementPhoto')" slot="dropdown">
          <el-dropdown-item  command="delete">{{$t('common.delete')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <br />
      
    </div>
    <div>
      <custom-image :src="photo.url" class="photo-index" fit="contain" :preview-src-list="photos"/>
      <br />
    </div>
  </el-card>
</template>

<script>
import dayjs from "dayjs-ext";
import axios from "axios";
import {mapState} from "vuex"
import preferences from "../util/preferences"

export default {
  name: "CreateRoute",
  events: ["created"],
  components: {},
  props: ["photo","photos"],
  data() {
    return {
      date: "",
      editing: false,
      options: {
        label: "name",
        children: "children",
        checkbox: false,
      },
    };
  },
  created() {
    this.date = dayjs(this.photo.date).format(preferences().localization.dateFormat);
  },
  mounted() {},
  computed: {
    ...mapState("account", ["customer"]),
  },
  methods: {
    remove() {
       this.$confirm(this.$t("common.AreYouSure"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.warningConfirmText"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
      })
        .then(() => {
          var id = this.$route.params.id;
          axios.delete(
            `${process.env.VUE_APP_APIURL}/measurement/${id}/photo/${this.photo.key.split("/")[1]}`
          );
        })
        .then(() => {
          this.$emit("deleted",this.photo.key);
          this.$message({
            type: "success",
            message: this.$t("tree.deleteCompleted"),
          });
        });
    },
    handleCommand(command) {
      switch (command) {
        case "delete":
          this.remove();
          break;
      }
    },
  },
};
</script>

<style scoped>
.photo {
  width: 22%;
  margin: 10px;
}
.photo-index {
  width: 100%;
}
.text {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.pointNumber {
  margin-top: 5px;
  float: right;
  padding: 3px 0;
}
</style>